import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import SaveIcon from '@material-ui/icons/Save';
import React from 'react';
import formatNum from '../../../../utils/helpers';
import { Box } from '../../../UI';

export default function Exit({ data, setExitCapRate }) {
	const { year, gri, price, tc, exitCapRate, exitPrice, exitPricePerSqFt } = data;
	return (
		<ExpansionPanel style={{ background: '#eee' }}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Exit</strong>
					<Tooltip title="Exit assumption to be inserted by the user" aria-label="info">
						<IconButton color="inherit" aria-label="menu">
							<InfoIcon style={{ fontSize: '16px' }} color="primary" />
						</IconButton>
					</Tooltip>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<Box display="flex" flexDirection="column" width="100%">
					<TableContainer>
						<Table aria-label="simple table">
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Exit Year</strong>
									</TableCell>
									<TableCell align="right">{year}</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Exit GRI</strong>
									</TableCell>
									<TableCell align="right">£{gri.toLocaleString()}</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Exit Cap Rate</strong>
									</TableCell>
									<TableCell align="right">
										<TextField
											style={{ width: '80px' }}
											type="number"
											value={exitCapRate}
											onChange={event => setExitCapRate(event.target.value)}
											InputLabelProps={{
												shrink: true,
											}}
											InputProps={{
												endAdornment: <InputAdornment position="end">%</InputAdornment>,
												inputProps: {
													max: 100,
													min: 1,
												},
											}}
										/>
										<IconButton color="inherit" aria-label="menu" disabled>
											<EditIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Exit Price</strong>
									</TableCell>
									<TableCell align="right">£{formatNum(exitPrice)}</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Exit Price per sq ft</strong>
									</TableCell>
									<TableCell align="right">£{formatNum(exitPricePerSqFt)}</TableCell>
									<TableCell />
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Exit TC</strong>
									</TableCell>
									<TableCell align="right">£{tc.toLocaleString()}</TableCell>
									<TableCell>0.40%</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					<Box display="flex" justifyContent="flex-end" mt='1rem'>
						<Button variant="contained" color="primary" startIcon={<SaveIcon />}>
							Save changes
						</Button>
					</Box>
				</Box>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
